import AbstractParallelogram from "./AbstractParallelogram";

export default class Parallelogram extends AbstractParallelogram {
	static NAME = "parallelogram";

	get_name() {
		return Parallelogram.NAME;
	}
}
